type Props = {
  roundIndex: number;
  confidence: number;
};

// Targeting stops dynamically once the model is confident; there is no fixed
// round count, so progress tracks confidence toward the stop threshold.
const STOP_THRESHOLD = 0.85;

export function TargetingProgress({ roundIndex, confidence }: Props) {
  const clamped = Math.min(1, Math.max(0, confidence));
  const pct = Math.round(Math.min(1, clamped / STOP_THRESHOLD) * 100);
  const ready = clamped >= STOP_THRESHOLD;
  return (
    <div className="flex flex-col gap-2">
      <div className="text-neutral-650 flex items-center justify-between text-sm">
        <span className="font-medium">Round {roundIndex}</span>
        <span>{ready ? 'Ready to search' : 'Tuning the search…'}</span>
      </div>
      <div className="bg-secondary-150 h-1.5 w-full overflow-hidden rounded-full">
        <div
          className="bg-primary h-full rounded-full transition-[width] duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
